
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic-board/[keyword]",
      function () {
        return require("private-next-pages/topic-board/[keyword].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic-board/[keyword]"])
      });
    }
  